import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import { IFlightType, IFlightTypeForm } from 'src/models/flight-type.model';
import { useFlightTypeContext } from 'src/contexts/flight-type.context';
import Lang from 'src/libraries/language';
import { actionTypes } from 'src/ducks/flight-type.duck';
import { getFlightTypeStatus } from 'src/selectors/flight-type.selector';
import FlightTypeForm from '../flight-types-form/flight-types-form.component';
import style from '../flight-types-list/flight-types-list.module.scss';

type IProp = {
  data: IFlightType;
};

const FlightTypeEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useFlightTypeContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues: Partial<IFlightType> = {
    flightType: '',
  };

  if (data) {
    defaultValues = data;
  }

  const editStatus = getFlightTypeStatus(state, actionTypes.FLIGHT_TYPE_UPDATE);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (value) => {
      const formData: IFlightTypeForm = {
        flightType: value.flightType,
      };
      const response = await actions.updatePUT(value.flightTypeId, formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_FLIGHT_TYPE_EDIT_SUCCESS,
            formData.flightType ? formData.flightType : value.flightType
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      actions.listGET();
    },
    [actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_EDIT_FLIGHT_TYPE}
      content={
        <div className={style.content}>
          <FlightTypeForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default FlightTypeEdit;
